// extracted by mini-css-extract-plugin
export default {"background":"Modal_background__sc7YN","modal":"Modal_modal__05KRQ","hr":"Modal_hr__-Jq2F"};